import React from 'react'

import { Card, Flex, Skeleton, Text } from '@driftt/dds'
import { TypeFormats } from '@driftt/dds.reports'

import { StyledCardEvent } from './TimelineEventTemplate.styled'
import { TimelineEventProps } from './TimelineEventTemplate.types'

export const TimelineEventTemplate = ({
  header = '',
  date = '',
  children,
  headerLeftElement = null,
  headerRightElement = null,
  isLoading = false,
}: TimelineEventProps) => {
  return (
    <Flex direction="column" fullWidth>
      <Skeleton isLoading={isLoading} height={20} width={150}>
        <Text variant="body">
          {TypeFormats.SIMPLE_DATE_TIME(new Date(date))}
        </Text>
      </Skeleton>
      <Skeleton isLoading={isLoading} height={80}>
        <StyledCardEvent width="100%">
          <Card.Content
            as={Flex}
            gap={2}
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Flex justifyContent="flex-start" fullHeight>
              {headerLeftElement}
            </Flex>
            <Flex direction="column" fullHeight fullWidth>
              {header}
              {children}
            </Flex>
            <Flex justifyContent="flex-start" fullHeight>
              {headerRightElement}
            </Flex>
          </Card.Content>
        </StyledCardEvent>
      </Skeleton>
    </Flex>
  )
}
